import React, { useEffect, useState } from "react";
import { getPosts } from "./api/forumApi";
import ForumCard from "../components/ForumCard";
import { useNavigate } from "react-router-dom";

export default function Forums() {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getPosts().then(res => {
      setPosts(res.data);
    });
  }, []);

  return (
    <div className="container">
      <h1>Announcements</h1>

      <button className="create-btn" onClick={() => navigate("/create")}>
        + Create Post
      </button>

      <div className="forum-list">
        {posts.map(post => (
          <ForumCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
}